import React from "react";
import "./SideMenu.scss";
import { LogoImg2 } from "assets/images";
import { NavLink } from "react-router-dom";
import {
  MdContentCopy,
  MdContentPaste,
  MdDashboard,
  MdHeadsetMic,
  MdImage,
  MdLibraryBooks,
  MdSupervisorAccount,
} from "react-icons/md";
import { TbCalendarMonth, TbTruckDelivery, TbCategoryPlus} from "react-icons/tb";
import { FcSurvey } from "react-icons/fc";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import {
  FaBoxOpen,
  FaQuestionCircle,
  FaRegBell,
  FaTag,
  FaUser,
  FaUserCog,
} from "react-icons/fa";
import { usePermission } from "context/permission_context";
import { RiAdminLine, RiCoupon3Line, RiHandCoinFill } from "react-icons/ri";
import { LiaShippingFastSolid } from "react-icons/lia";
import { BiSolidOffer, BiSupport, BiSolidCategoryAlt } from "react-icons/bi";
import { SiStockx } from "react-icons/si";
import { MdCategory, MdPayment } from "react-icons/md";
import { FaFilter, FaFilePrescription } from "react-icons/fa";
import { AiOutlineTransaction } from "react-icons/ai";


const sideMenuData = (permission) => {
  return [
    {
      category: "General",
      items: [
        {
          id: 101,
          enabled: true,
          path: "/dashboard",
          name: "Dashboard",
          icon: <MdDashboard />,
        },
        {
          id: 102,
          enabled: true,
          name: "User Management",
          path: "/user-management",
          icon: <FaUserCog />,
        },
        {
          id: 302,
          enabled: true,
          name: "Sub-Admin Management",
          path: "/sub-admin-management",
          icon: <RiAdminLine />,
        },
      ]
    },
    {
      category: "Catalog & Inventory",
      items: [
        {
          id: 103,
          enabled: true,
          path: "/category-management",
          name: "Category Management",
          icon: <TbCategoryPlus />,
        },
        {
          id: 144,
          enabled: true,
          path: "/sub-Category-Management",
          name: "Sub Category Management",
          icon: <MdCategory />,
        },
        {
          id: 104,
          enabled: true,
          path: "/sub-sub-Category",
          name: "Filter Category",
          icon: <FaFilter />,
        },
        {
          id: 105,
          enabled: true,
          name: "Product Management",
          path: "/product-management",
          icon: <FaBoxOpen />,
        },
        {
          id: 303,
          enabled: true,
          name: "Out Of Stock/Low Stock",
          path: "/out-of-stock",
          icon: <SiStockx />,
        },
        {
          id: 304,
          enabled: true,
          name: "Over Stock",
          path: "/high-stock",
          icon: <SiStockx />,
        },
      ]
    },
    {
      category: "Sales & Finance",
      items: [
        {
          id: 106,
          enabled: true,
          name: "Order Management",
          path: "/order-management",
          icon: <LiaShippingFastSolid />,
        },
        {
          id: 107,
          enabled: true,
          name: "Prescription Management",
          path: "/prescription-management",
          icon: <FaFilePrescription />,
        },
        {
          id: 109,
          enabled: true,
          name: "Transaction Management",
          path: "/transaction-management",
          icon: <AiOutlineTransaction />,
        },
        {
          id: 901,
          enabled: true,
          name: "Payment Management",
          path: "/payment-management",
          icon: <MdPayment />,
        },
      ]
    },
    {
      category: "Marketing & Brand",
      items: [
        {
          id: 110,
          enabled: true,
          name: "Manage Coupon Code",
          path: "/promocode-management",
          icon: <RiCoupon3Line />,
        },
        {
          id: 220,
          enabled: true,
          name: "Offer Management",
          path: "/offer-management",
          icon: <BiSolidOffer />,
        },
        {
          id: 111,
          enabled: true,
          path: "/brand-management",
          name: "Manage Brand",
          icon: <FaTag />,
        },
        {
          id: 202,
          enabled: true,
          name: "Coins Management",
          path: "/coin-management",
          icon: <RiHandCoinFill />,
        },
        {
          id: 114,
          enabled: true,
          name: "Banner Management",
          path: "/banner-management",
          icon: <MdImage />,
        },
        //   {
        //   id: 174,
        //   enabled: true,
        //   name: "Rating Management",
        //   path: "/rating-management",
        //   icon: <MdImage />,
        // },
      ]
    },
    {
      category: "Operations & Support",
      items: [
        {
          id: 201,
          enabled: true,
          name: "Manage Delivery Slots & Fees",
          path: "/Manage-delivery-slots-fees",
          icon: <TbTruckDelivery />,
        },
        {
          id: 112,
          enabled: true,
          path: "/customer-support",
          name: "Manage Customer Support",
          icon: <BiSupport />,
        },
        {
          id: 1009,
          enabled: true,
          path: "/notification",
          name: "Notifications Management",
          icon: <FaRegBell />,
        },
        {
          id: 108,
          enabled: true,
          name: "Content Management",
          path: "/Content-management",
          icon: <MdContentPaste />,
        },
      ]
    }
  ].map((group) => ({
    ...group,
    items: group.items.filter((item) => item.enabled),
  })).filter((group) => group.items.length > 0);
};

const SideMenu = ({ toggleSidebar }) => {
  const { permission } = usePermission();

  return (
    <>
      <aside className="aside">
        <div className="logo">
          <img src={LogoImg2} alt="SINDHI" />
        </div>
        <div className="side_menu">
          {sideMenuData(permission) &&
            sideMenuData(permission).map((group, index) => (
              <div key={index} className="menu_group">
                <h6 className="group_title">{group.category}</h6>
                <ul>
                  {group.items.map(({ id, path, name, icon }) => (
                    <li key={id}>
                      <NavLink to={path} onClick={toggleSidebar}>
                        <span className="menu_icon">{icon}</span>
                        <span className="menu_text">{name}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      </aside>
    </>
  );
};

export default SideMenu;
